import { render, staticRenderFns } from "./client-layout.vue?vue&type=template&id=5f6cfbe8&scoped=true"
import script from "./client-layout.vue?vue&type=script&lang=js"
export * from "./client-layout.vue?vue&type=script&lang=js"
import style0 from "./client-layout.vue?vue&type=style&index=0&id=5f6cfbe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6cfbe8",
  null
  
)

export default component.exports